import React, { useEffect, useState, useCallback, useRef } from "react";
import Button from "../../components/common/ui/Button";
import {
  CheckBoxInput,
  TextAreaInput,
} from "../../components/common/ui/Inputs";
import ReadDelete from "../../assets/svg/read-and-delete.svg";
import UnReadMsgDelete from "../../assets/svg/unread-message-delete.svg";
import MessageQuaratine from "../../assets/svg/Quarantine_msg.svg";
import ReadMessage from "../../assets/svg/Read-Message.svg";
import UnReadmail from "../../assets/svg/unread-icon-new.svg";
import RejectQuarantine from "../../assets/svg/Quarantine_rejected_msg.svg";
import CODPending from "../../assets/svg/cod_pending.svg";
import ApproveImg from "../../assets/svg/approve-icon.svg";
import RejectImg from "../../assets/svg/reject.svg";
import CustomLoader from "../../components/common/ui/Loader";
import translateText from "../../_helpers/GoogleTranslator";
import { formatDate } from "../../utils/formatTime";

// Utility: escape regex special characters
const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

// Utility: add space between emojis and text
function addSpaceBetweenEmojisAndText(message) {
  const emojiWithTextRegex = /([\p{Extended_Pictographic}]+)(?=\w)/gu;
  const textBeforeEmojiRegex = /(\w)([\p{Extended_Pictographic}]+)/gu;

  if (Array.isArray(message)) {
    return message.map((msg) => {
      return msg
        .replace(textBeforeEmojiRegex, "$1 $2")
        .replace(emojiWithTextRegex, "$1 ");
    });
  } else {
    return message
      .replace(textBeforeEmojiRegex, "$1 $2")
      .replace(emojiWithTextRegex, "$1 ");
  }
}

// Memoized row component for virtual list
const MessageViewerRow = React.memo(({
  item,
  index,
  showCompleteConvo,
  handleVerifyNotes,
  handleNotesChange,
  handleReviewNotes,
  handleApproveOrReject,
  updateSubjectContent,
  updateMessageContent,
  command,
  showmessagecontent,
}) => {
  const showMessageContent = useCallback((Value) => {
    return showmessagecontent(Value);
  }, [showmessagecontent]);

  if (!item) return null;


  return (
    <>
      <tr>
        <td >
          <div
            className={`${item?.IsSenderMsgDelete === 1 &&
              "text-decoration-line-through"
              }`}

            dangerouslySetInnerHTML={{
              __html:
                showMessageContent(item?.MessageSubject) ||
                updateSubjectContent[index],
            }}
          ></div>
        </td>
        <td >
          <div >
            <span
              className={`${item?.Sender === "Inmate"
                ? "red-color me-2"
                : "text-success me-2"
                }`}
            >
              &#9679;
            </span>
            {item?.MessageFrom}
          </div>
        </td>
        <td >
          <span
            className={`${item?.Sender === "PublicUser"
              ? "red-color me-2"
              : "text-success me-2"
              }`}
          >
            &#9679;
          </span>
          {item?.MessageTo}
        </td>
        <td >{item?.MessageCost?.toFixed(2)}</td>
        <td >{item?.MessageReviewCommandBy || "-"}</td>
      </tr>

      {/* Detail Row */}
      <tr>
        <td colSpan="5">
          <div className="d-flex justify-content-between align-items-center p-3 border-bottom-1">
            <div className="width-80">
              <p className="red-color fw-bold font-size-12">
                {formatDate(item?.MessageSentDate)}
              </p>
              <p
                style={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  width: "100%",
                  wordBreak: "break-word",
                }}
                className="pre-wrap-text"
              >
                <h3
                  className={`font-size-16 line-height-1 ${item?.IsSenderMsgDelete === 1 &&
                    "text-decoration-line-through"
                    }`}
                  dangerouslySetInnerHTML={{
                    __html:
                      showMessageContent(item?.MessageBody) ||
                      updateMessageContent[index],
                  }}
                ></h3>
              </p>
            </div>
            <div className="width-20">
              <p>
                {item?.MessageStatus === "Read" &&
                  item?.IsReceiverMsgDelete === 1 ? (
                  <div title="Read & Message Deleted">
                    <img
                      alt="status"
                      className="msg-icon"
                      src={ReadDelete}
                      style={{ margin: "0 auto", display: "block" }}
                    />
                  </div>
                ) : item?.MessageStatus === "Unread" &&
                  item?.IsReceiverMsgDelete === 1 ? (
                  <div title="Unread & Message Deleted">
                    <img
                      alt="status"
                      className="msg-icon"
                      src={UnReadMsgDelete}
                      style={{ margin: "0 auto", display: "block" }}
                    />
                  </div>
                ) : item?.MessageStatus === "Read" ? (
                  <div title="Read">
                    <img
                      alt="status"
                      className="msg-icon"
                      src={ReadMessage}
                      style={{ margin: "0 auto", display: "block" }}
                    />
                  </div>
                ) : item?.MessageStatus === "Unread" ? (
                  <div title="Unread">
                    <img
                      alt="status"
                      src={UnReadmail}
                      style={{
                        height: "30px",
                        width: "30px",
                        margin: "0 auto",
                        display: "block",
                      }}
                    />
                  </div>
                ) : item?.MessageStatus === "Pending Quarantine Approval" ? (
                  <div title="Quarantine Message">
                    <img
                      alt="status"
                      className="msg-icon"
                      src={MessageQuaratine}
                      style={{ margin: "0 auto", display: "block" }}
                    />
                  </div>
                ) : item?.MessageStatus === "Reject Quarantine" ? (
                  <div title="Quarantine Rejected">
                    <img
                      alt="status"
                      className="msg-icon"
                      src={RejectQuarantine}
                      style={{ margin: "0 auto", display: "block" }}
                    />
                  </div>
                ) : (
                  <div title="C.O.D Pending">
                    <img
                      alt="status"
                      className="msg-icon"
                      src={CODPending}
                      style={{ margin: "0 auto", display: "block" }}
                    />
                  </div>
                )}
              </p>
            </div>
          </div>

          <div className="row col-lg-12 col-sm-12 col-md-12 mt-2">
            {item?.FacilityReview == 1 &&
              item?.FacilityReviewStatus == "1" ? (
              <>
                <div className="col-lg-2 col-md-2 col-sm-2 mt-4">
                  <div className="form-floating mb-3">
                    <CheckBoxInput
                      id={`messageNotesVerify_${index}`}
                      name={`messageNotesVerify_${index}`}
                      handleClick={(e) => handleVerifyNotes(e, index, item?.MessageID)}
                      checked={item?.isVerifyCheckbox || item?.MessageReviewCommand?.trim()?.length > 0 ? true : false}
                      label={"Notes"}
                    />
                  </div>
                </div>
                <div className="col-lg-7 col-md-7 col-sm-6">
                  <div className="form-floating mb-3">
                    <TextAreaInput
                      disabled={
                        item?.FacilityReview === 1 &&
                        (item?.MessageReviewCommand !== "" ||
                          item?.MessageReviewCommandBy !== "") &&
                        item?.FacilityReviewStatus === "1"
                      }
                      name={`command_${index}`}
                      className="command"
                      handleChange={(e) => handleNotesChange(e, index)}
                      rows={3}
                      value={
                        item?.MessageReviewCommand || command?.[index]
                      }
                    // value={
                    //   command?.[index] || item?.MessageReviewCommand
                    // }
                    />
                  </div>
                </div>
              </>
            ) : (
              <div className="col-md-9"></div>
            )}
            <div className="col-lg-3 col-md-4 col-sm-4">
              {item?.FacilityReview === 1 &&
                item?.MessageReviewCommand === "" &&
                item?.MessageReviewCommandBy === "" &&
                item?.FacilityReviewStatus === "1" && (
                  <Button
                    disabled={!item?.isVerifyCheckbox}
                    label="Review"
                    status="primary"
                    icon={"fas fa-file-alt"}
                    type="button"
                    className="mt-3"
                    onClick={() =>
                      handleReviewNotes(item?.MessageID, index)
                    }
                  />
                )}
              {item?.MessageFlag === 2 &&
                item?.IsMsgApprove === 0 && (
                  <div className="d-flex flex-wrap gap-2">
                    <Button
                      label="Approve"
                      status="success"
                      type="button"
                      imgsrc={ApproveImg}
                      className="mt-3"
                      onClick={(e) =>
                        handleApproveOrReject(
                          item?.MessageID,
                          e,
                          "approve",
                          item
                        )
                      }
                    />
                    <Button
                      label="Reject"
                      status="primary"
                      type="button"
                      imgsrc={RejectImg}
                      className="mt-3"
                      onClick={(e) =>
                        handleApproveOrReject(
                          item?.MessageID,
                          e,
                          "reject",
                          item
                        )
                      }
                    />
                  </div>
                )}
            </div>
          </div>
        </td>
      </tr>
    </>
  );
});

MessageViewerRow.displayName = "MessageViewerRow";

const MessageViewer = ({
  data,
  totalRowCount,
  handleVerifyNotes,
  handleNotesChange,
  showCompleteConvo,
  handleReviewNotes,
  handleApproveOrReject,
  handlePrevNext,
  indexValue,
  messagesList,
  updateSubjectContent,
  updateMessageContent,
  command,
  setmessageIndex,
  messageIndex,
  selectLang,
  isNotesRef,
  messageitem,
  setmessageitem,
  isprevdisabled,
  isNextDisabled
}) => {
  const [isloading, setisloading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [scrollTop, setScrollTop] = useState(0);
  const scrollContainerRef = useRef(null);

  // Item height: 2 rows per message (header + detail) ~300px total
  const ITEM_HEIGHT = 300;
  const VISIBLE_ITEMS = 7; // Show ~7 messages at a time in 600px container

  // Show message content with keyword highlighting
  const showmessagecontent = useCallback((Value) => {
    Value = addSpaceBetweenEmojisAndText(Value);

    let quarantineKeywords = [];
    let KeyWordFilterType = [];

    data?.forEach((item) => {
      const keywords =
        item?.MessageBothFlagKeyWords || item?.MessageFlagKeyWords;
      if (keywords) {
        quarantineKeywords.push(...keywords.split("|"));
      }

      const filterTypes = item?.KeyWordFilterType?.split("|") || [];
      KeyWordFilterType.push(...filterTypes);
    });

    if (quarantineKeywords.length === 0) return Value;

    const patterns = quarantineKeywords.map((word, index) => {
      const filterType = KeyWordFilterType[index]?.toLowerCase();
      return filterType === "whole word"
        ? `\\b${escapeRegExp(word)}\\b`
        : escapeRegExp(word);
    });

    const regex = new RegExp(`(${patterns.join("|")})`, "gi");

    const highlightedMessageContent = String(Value)?.replace(regex, (match) => {
      return `<span style="color: red; font-weight: bold;">${match}</span>`;
    });

    return highlightedMessageContent;
  }, [data]);

  // Handle translation on data or language change
  useEffect(() => {
    const fetchTranslation = async () => {
      if (!data) return;

      if (selectLang !== "en" && selectLang !== "es") {
        setmessageitem(data);
        return;
      }

      setisloading(true);
      const originalSubject = addSpaceBetweenEmojisAndText(
        data[0]?.MessageSubject
      );
      const translatedSubject = await translateText(originalSubject, selectLang);

      const bodyCache = {};

      const translatedData = await Promise.all(
        data.map(async (option) => {
          const originalBody = addSpaceBetweenEmojisAndText(option.MessageBody);

          if (!bodyCache[originalBody]) {
            bodyCache[originalBody] = await translateText(
              originalBody,
              selectLang
            );
          }

          return {
            ...option,
            MessageSubject: translatedSubject,
            MessageBody: bodyCache[originalBody],
          };
        })
      );

      setmessageitem(translatedData);
      setisloading(false);
    };

    if (isNotesRef?.current) {
      isNotesRef.current = false;
      return;
    } else {
      fetchTranslation();
    }
  }, [data, selectLang, isNotesRef]);

  // Handle scroll for viewport calculation
  const handleScroll = (e) => {
    setScrollTop(e.target.scrollTop);
  };

  // Calculate visible range based on scroll position
  const startIndex = Math.max(0, Math.floor(scrollTop / ITEM_HEIGHT) - 1);
  const endIndex = Math.min(messageitem?.length || 0, startIndex + VISIBLE_ITEMS + 2);

  // Get visible items
  const visibleItems = messageitem?.slice(startIndex, endIndex) || [];

  return (
    <div className="">
      <div className="table-responsive">
        {messageitem && messageitem.length > 0 ? (
          <div
            ref={scrollContainerRef}
            onScroll={handleScroll}
            style={{
              height: showCompleteConvo ? "600px" : "auto",
              overflow: "auto",
              borderLeft: "1px solid #dee2e6",
              borderRight: "1px solid #dee2e6",
              borderBottom: "1px solid #dee2e6",
            }}
          >
            {/* Spacer for items before visible range */}
            <div style={{ height: startIndex * ITEM_HEIGHT }}></div>

            {/* Render only visible items */}
            <table className="table table-bordered" style={{ marginBottom: 0, width: "100%" }}>
              <thead>
                <tr style={{ backgroundColor: "#c8605e", color: "white", width: "100%" }}>
                  <th className="text-white" >Subject</th>
                  <th className="text-white " >From</th>
                  <th className="text-white" >To</th>
                  <th className="text-white" >Message Cost ($)</th>
                  <th className="text-white" >Reviewed By</th>
                </tr>
              </thead>
              <tbody>
                {visibleItems.map((item, idx) => (
                  <MessageViewerRow
                    key={item.MessageID || startIndex + idx}
                    item={item}
                    index={startIndex + idx}
                    showCompleteConvo={showCompleteConvo}
                    handleVerifyNotes={handleVerifyNotes}
                    handleNotesChange={handleNotesChange}
                    handleReviewNotes={handleReviewNotes}
                    handleApproveOrReject={handleApproveOrReject}
                    updateSubjectContent={updateSubjectContent}
                    updateMessageContent={updateMessageContent}
                    command={command}
                    showmessagecontent={showmessagecontent}
                  />
                ))}
              </tbody>
            </table>

            {/* Spacer for items after visible range */}
            <div style={{ height: Math.max(0, (messageitem.length - endIndex) * ITEM_HEIGHT) }}></div>
          </div>
        ) : (
          <div
            style={{
              minHeight: "200px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderLeft: "1px solid #dee2e6",
              borderRight: "1px solid #dee2e6",
              borderBottom: "1px solid #dee2e6",
            }}
          >
            <p className="text-muted">No messages to display</p>
          </div>
        )}
      </div>

      {!showCompleteConvo && (
        <>
          <div
            style={{ backgroundColor: "#e9e9e9", color: "white" }}
            className="d-flex flex-wrap justify-content-between align-items-center mt-2 p-2"
          >
            <span className="text-black">
              Total Number of Messages: {totalRowCount}
            </span>
            <span className="d-flex flex-wrap align-items-center text-black">
              <i
                className={`fas fa-arrow-alt-circle-left fs-4 mx-2 cursor-pointer ${messageIndex === 1 ? "disabled-icon" : ""
                  }`}
                onClick={() => setmessageIndex(Math.max(1, messageIndex - 1))}
                title="prev"
              ></i>

              <span>Page </span>
              <input
                type="number"
                min={1}
                max={totalRowCount}
                value={messageIndex}
                onChange={(e) => {
                  setmessageIndex(e.target.value);
                }}
                onBlur={() => {
                  const newPage = Number(messageIndex);
                  if (
                    newPage >= 1 &&
                    newPage <= totalRowCount &&
                    newPage !== currentPage
                  ) {
                    setmessageIndex(newPage);
                    setcurrentPage(newPage);
                  } else {
                    setmessageIndex(currentPage);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    const newPage = Number(messageIndex);
                    if (
                      newPage >= 1 &&
                      newPage <= totalRowCount &&
                      newPage !== currentPage
                    ) {
                      setmessageIndex(newPage);
                    }
                  }
                }}
                className="small-input"
                style={{
                  width: 50,
                  textAlign: "center",
                  borderRadius: 4,
                  border: "1px solid #ccc",
                  padding: "2px 4px",
                }}
              />
              <span className="mx-2">/ {totalRowCount}</span>

              <i
                className={`fas fa-arrow-alt-circle-right fs-4 mx-2 cursor-pointer ${totalRowCount === messageIndex ? "disabled-icon" : ""
                  }`}
                onClick={() =>
                  setmessageIndex(Math.min(totalRowCount, messageIndex + 1))
                }
                title="next"
              ></i>
            </span>
          </div>
          <div className="d-flex flex-wrap justify-content-between mt-3">
            <Button
              label="PREV"
              status="btn-label"
              type="button"
              icon={"fas fa-arrow-alt-circle-left"}
              onClick={() => handlePrevNext("prev")}
              disabled={isprevdisabled}
            />
            <Button
              label="NEXT"
              status="btn-label"
              type="button"
              disabled={isNextDisabled}
              icon={"fas fa-arrow-alt-circle-right"}
              onClick={() => handlePrevNext("next")}
            />
          </div>
        </>
      )}
      {isloading && <CustomLoader />}
    </div>
  );
};

export default React.memo(MessageViewer);
